import domReady from '@roots/sage/client/dom-ready';
import ScrollReveal from 'scrollreveal';
import Header from './components/commons/header/header';
import Hamburger from './components/commons/header/hamburger';
import CardList from './components/card/card-list';
import GMap from './components/commons/gmap';
import ParallaxBg from './components/parallax-bg';
import Contact from './pages/contact';
import CanvasScrollClip from "canvas-scroll-clip";

(g=>{var h,a,k,p="The Google Maps JavaScript API",c="google",l="importLibrary",q="__ib__",m=document,b=window;b=b[c]||(b[c]={});var d=b.maps||(b.maps={}),r=new Set,e=new URLSearchParams,u=()=>h||(h=new Promise(async(f,n)=>{await (a=m.createElement("script"));e.set("libraries",[...r]+"");for(k in g)e.set(k.replace(/[A-Z]/g,t=>"_"+t[0].toLowerCase()),g[k]);e.set("callback",c+".maps."+q);a.src=`https://maps.${c}apis.com/maps/api/js?`+e;d[q]=f;a.onerror=()=>h=n(Error(p+" could not load."));a.nonce=m.querySelector("script[nonce]")?.nonce||"";m.head.append(a)}));d[l]?console.warn(p+" only loads once. Ignoring:",g):d[l]=(f,...n)=>r.add(f)&&u().then(()=>d[l](f,...n))})({
  key: "AIzaSyD8bE4ZsrRbymIQuIQ96TsX-sV_wFG5Vz0",
  v: "weekly",
});

/**
 * Application entrypoint
 */
domReady(async () => {
  Header.exec();
  Hamburger.exec();
  CardList.exec();
  GMap.exec();
  ParallaxBg.exec();
  Contact.exec();
  ScrollReveal().reveal('.scroll-reveal', {
    delay: 100,
    duration: 2000,
    reset: false,
  });

  new CanvasScrollClip(document.querySelector('.layers'), {
    framePath: "/wp-content/themes/fournet-wordpress-theme/public/images/layers/layers_00000.jpg",
    frameCount: 479,
    scrollArea: 3000
  })


});

/**
 * @see {@link https://webpack.js.org/api/hot-module-replacement/}
 */
if (import.meta.webpackHot) import.meta.webpackHot.accept(console.error);
